import { DialogCloseButton } from '@/components/DialogCloseButton';
import { Dialog, DialogTitle, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { ReactNode } from 'react';

interface Props {
  title: ReactNode;
  open: boolean;
  children: React.ReactNode;
  onClose?: () => void;
}
export const GeneralDialog = (props: Props) => {
  const { title, open, children, onClose } = props;
  const theme = useTheme();
  const isSmallScreens = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog fullWidth onClose={onClose} open={open} fullScreen={isSmallScreens}>
      <DialogTitle>
        {typeof title === 'string' ? (
          <Typography variant="h5" noWrap>
            {title}
          </Typography>
        ) : (
          title
        )}
        {onClose && <DialogCloseButton onClick={onClose} />}
      </DialogTitle>
      {children}
    </Dialog>
  );
};
